import * as gtm from '../services/gtm'
import * as gtg from '../services/gtag'

export const montarObjetoGoogle = (produto: any) => {
  const conteudoProduto = {
    titulo: produto.titulo_produto,
    marca_slug: produto.marca_slug,
    categoria: {
      nome: produto.nome_categoria,
    },
  }

  const variacaoAtiva = {
    id: produto.variacao.id,
    combinacoes: produto.variacao.combinacoes_lista.map((combinacao: any) => {
      return {
        atributo_slug: combinacao.atributo_slug,
        valor_slug: combinacao.valor_slug,
        valor: combinacao.valor,
      }
    }),
    anuncios: [
      {
        formas_pagamento: {
          boleto: {
            por: produto.anuncio.formas_pagamento?.boleto?.por,
          },
        },
        preco: {
          por: produto.anuncio.preco?.por,
        },
      },
    ],
  }

  const gtmProduto = gtm.gtmProduto(conteudoProduto, variacaoAtiva, {
    quantity: produto.quantidade,
    id: produto.variacao.id,
  })

  const gtgProduto = gtg.gtgProduto(conteudoProduto, variacaoAtiva, {
    quantity: produto.quantidade,
    id: produto.variacao.id,
  })

  return { gtmProduto, gtgProduto }
}
